import { safeCallSegment } from '../helpers';

export function trackSwitchMatchingProfile(mp: { id: string; name: string }): void {
  safeCallSegment(() => {
    analytics.track('Switch matching profile', {
      mp
    });
  });
}

// MP: edit monitoring profile
export function trackMPEditMonitoringProfile(mp: { id: string; name: string }): void {
  safeCallSegment(() => {
    analytics.track('MP edit monitoring profile', {
      mp
    });
  });
}

// MP: edit keyword shortcut
export function trackMPEditKeywordShortcut(mp: { id: string; name: string }): void {
  safeCallSegment(() => {
    analytics.track('MP edit keyword shortcut', {
      mp
    });
  });
}

// MP: edit add keywords
export function trackMPEditAddKeywords(mp: { id: string; name: string }): void {
  safeCallSegment(() => {
    analytics.track('MP edit add keywords', {
      mp
    });
  });
}

// MP: edit add CPV-code
export function trackMPEditAddCPVCode(mp: { id: string; name: string }, checked: boolean, optionId: string): void {
  safeCallSegment(() => {
    analytics.track('MP edit add CPV-code', {
      mp,
      checked,
      optionId
    });
  });
}

// MP: edit search CPV-code
export function trackMPEditSearchCPVCode(mp: { id: string; name: string }): void {
  safeCallSegment(() => {
    analytics.track('MP edit search CPV-code', {
      mp
    });
  });
}

// MP: edit add region
export function trackMPEditAddRegion(mp: { id: string; name: string }, checked: boolean, optionId: string): void {
  safeCallSegment(() => {
    analytics.track('MP edit add region', {
      mp,
      checked,
      optionId
    });
  });
}

// MP: edit search region
export function trackMPEditSearchRegion(mp: { id: string; name: string }): void {
  safeCallSegment(() => {
    analytics.track('MP edit search region', {
      mp
    });
  });
}

// MP: edit add buyers
export function trackMPEditAddBuyers(mp: { id: string; name: string }): void {
  safeCallSegment(() => {
    analytics.track('MP edit add buyers', {
      mp
    });
  });
}

// MP: edit have access
export function trackMPEditHaveAccess(mp: { id: string; name: string }): void {
  safeCallSegment(() => {
    analytics.track('MP edit have access', {
      mp
    });
  });
}

// MP: edit owners
export function trackMPEditOwners(mp: { id: string; name: string }): void {
  safeCallSegment(() => {
    analytics.track('MP edit owners', {
      mp
    });
  });
}

// MP: edit delete
export function trackMPEditDelete(mp: { id: string; name: string }): void {
  safeCallSegment(() => {
    analytics.track('MP edit delete', {
      mp
    });
  });
}

// MP: edit update results
export function trackMPEditUpdateResults(mp: { id: string; name: string }): void {
  safeCallSegment(() => {
    analytics.track('MP edit update results', {
      mp
    });
  });
}

// MP: edit press cross
export function trackMPEditPressCross(mp: { id: string; name: string }, updated: boolean): void {
  safeCallSegment(() => {
    analytics.track('MP edit press cross', {
      mp,
      updated
    });
  });
}
